export function throwDeprecatedErrorForReducer(reducerName) {
  throw new Error(`This reducer has been deprecated : ${reducerName}`);
}

export function logWarningForDeprecatedReducerWithReplacementReducer(deprecatedReducerName, replacementReducerName) {
  console.warn(`This reducer is deprecated and will soon be removed : "${deprecatedReducerName}", please use instead this reducer : "${replacementReducerName}"`);
}

export function logWarningForDeprecatedReducer(deprecatedReducerName) {
  console.warn(`This reducer is deprecated and will soon be removed : "${deprecatedReducerName}", it is part of a functionnality that is not used anymore, please do not use it.`);
}


// WEBPACK FOOTER //
// ./src/utils/deprecation.js